export default "__VITE_ASSET__CbbjIqZ4__"